import { useId, useState } from 'react'

import { ArrowRight } from '@/components/icons/ArrowRight'
import { getSlugTranslation } from '@/locale/utils'

export const PatientQuestionCard = ({ question }: { question: string }) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const contentId = useId()

  return (
    <section className="w-full rounded-2xl bg-white shadow-sm" data-testid="patient-question-card">
      <button
        aria-controls={contentId}
        aria-expanded={isExpanded}
        className="flex w-full items-center justify-between p-4 text-left"
        onClick={() => setIsExpanded((expanded) => !expanded)}
        type="button"
      >
        <span className="text-gray-text text-sm font-semibold uppercase">{getSlugTranslation('general.consultation.followupCard.yourMessage')}</span>

        <span className="flex size-6 items-center justify-center" aria-hidden="true">
          <ArrowRight className={`h-3.5 w-[9px] ${isExpanded ? 'text-primary rotate-90' : 'text-text'}`} />
        </span>
      </button>

      {isExpanded && (
        <p className="px-4 pb-6 wrap-break-word whitespace-break-spaces" id={contentId}>
          {question}
        </p>
      )}
    </section>
  )
}
